import type { ChartDataPoint } from "../types";

/**
 * Calculate Y-axis domain based on chart data and selected choices
 */
export const calculateYAxisDomain = (
  choiceProbabilityTimeline: ChartDataPoint[],
  selectedChoiceIds: string[],
): [number, number] => {
  if (choiceProbabilityTimeline.length === 0) return [0, 100];

  let maxValue = 0;

  // Find the maximum value across all selected choices
  for (const dataPoint of choiceProbabilityTimeline) {
    for (const choiceId of selectedChoiceIds) {
      const value = Number.parseFloat(dataPoint[choiceId]);
      if (!Number.isNaN(value) && value > maxValue) {
        maxValue = value;
      }
    }
  }

  // Add some padding to the top
  const upperBound = Math.min(100, Math.ceil((maxValue * 1.1) / 10) * 10);

  // If max value is less than 50%, use a smaller scale
  if (maxValue < 50) {
    return [0, Math.max(50, upperBound)];
  }

  return [0, 100];
};
